<template>
    <div class="modal modal-open" id="modal-add-niche">
        <div class="modal-overflow">
            <div class="modal-window">
                <button class="btn btn-modal-close" @click="handleClose">
                    <i class="icon icon-cancel"></i>
                </button>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--text">
                                <label for="name">Name of Niche</label>
                                <input type="text" v-model="name" id="name" />
                                <span class="error" v-if="error">{{
                                    error
                                }}</span>
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12">
                            <div class="btn-wrap flex jus-c--center">
                                <button
                                    @click="handleAdd"
                                    type="button"
                                    class="btn"
                                >
                                    Add
                                </button>
                                <button
                                    @click="handleClose"
                                    type="button"
                                    class="btn"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
    name: "addNiche",
    props: {
        onClose: {
            type: Function,
            required: true,
        },
        onAdd: {
            type: Function,
            required: true,
        },
    },
    components: {
        Treeselect,
    },
    data() {
        return {
            name: "",
            error: null,
        };
    },

    methods: {
        handleClose(e) {
            this.onClose(e);
        },

        handleAdd() {
            if (this.validationFields()) {
                return;
            }

            this.onAdd({
                name: this.name,
            });
        },

        validationFields() {
            if (!this.name) {
                this.error = "Required";
                return true;
            }

            this.error = null;

            return false;
        },
    },
};
</script>
